import { DetailedHTMLProps, InputHTMLAttributes } from "react";
import { useMegaOptionGroup } from "../MegaOptionGroup";

interface IMegaOption
    extends DetailedHTMLProps<
        InputHTMLAttributes<HTMLInputElement>,
        HTMLInputElement
    > {
    title?: string;
    description?: string;
    inline?: boolean;
    wrapperClassName?: string;
}

export default function MegaOption(props: IMegaOption) {
    const { title, description, ...inputProps } = props;

    const { name, checked, onChange } = useMegaOptionGroup();
    return (
        <div className={props.wrapperClassName ?? "my-1"}>
            <label
                className={`option ${
                    checked === props.value ? "active" : ""
                } h-100 ${props.inline ? "d-flex-inline" : ""}`}
                role={"button"}
            >
                <span className="option-control">
                    <span className={props.type ?? "radio"}>
                        <input
                            {...inputProps}
                            type={props.type ?? "radio"}
                            name={props.name ?? name}
                            onChange={(...args) => {
                                onChange(String(props.value) ?? "");
                                props.onChange?.(...args);
                            }}
                        />
                        <span></span>
                    </span>
                </span>
                <span className="option-label">
                    <span className="option-head">
                        <span className="option-title">{title}</span>
                    </span>
                    <span className="option-body text-secondary">
                        {description}
                    </span>
                </span>
            </label>
        </div>
    );
}
